export const traditionalChinesePageText = {
  "No image embeddings yet. Close this window, click Start under Embedding, and wait for the task to finish.": "尚未生成圖片特徵。請關閉此視窗，在 Embedding 下點擊 Start，並等待任務完成。",
  "Extract DINOv2 features first": "請先提取 DINOv2 特徵",
  "Some images have no embedding. Extract features again": "部分圖片缺少特徵，請重新提取",
  "No similar images meet this threshold. Try a lower threshold.": "沒有符合此閾值的相似圖片，請降低閾值再搜尋。",
  "Search Similar Images": "搜尋相似圖片",
  "Extract features first, then select a reference image. Search is limited to this dataset.": "請先提取特徵，再選擇參考圖片。搜尋範圍僅限目前資料集。",
  "Reference Image": "參考圖片",
  "Similarity Threshold": "相似度閾值",
  "Similar Images": "相似圖片",
  "Matches": "符合數量",
  "Showing up to 50 results": "最多顯示 50 筆結果",
  "Searching…": "搜尋中…",
  "Task Mode": "任務模式",
  "Pre-labeling": "預先標註",
  "Embedding": "Embedding",
  "Run pre-labeling or DINOv2 feature extraction against selected datasets.": "對所選資料集執行預先標註或 DINOv2 特徵提取。",
  "Generating images…": "正在生成圖片…",
  "Generation complete": "圖片生成完成",
  "Generation failed": "圖片生成失敗",
  "No images generated": "未生成圖片",
  "Generation cancelled": "已取消生成",
  "Stable Diffusion 1.5": "Stable Diffusion 1.5",
  "Anomaly Synthesis": "異常合成",
  "API Image Generation": "API 圖片生成",
  "Elapsed": "已用時間",
  "You can close this window and follow progress on the dataset card.": "可關閉此視窗，並在資料集卡片上查看生成進度。",
  "No new images were returned. Check the generation settings and try again.": "未返回新圖片，請檢查生成設定後重試。",
  "Workspace": "工作區",
  "Dataset overview": "資料集概覽",
  "Manage image, audio, and table datasets for MLOps workflows.":
    "管理 MLOps 工作流程使用的圖片、音訊與資料表資料集。",
  "Browse, split, and manage datasets for downstream annotation and training workflows.":
    "瀏覽、分割並管理下游標註與訓練工作流程所使用的資料集。",
  "Dataset workspace navigation": "資料集工作區導覽",
  "Datasets": "資料集",
  "Images": "影像",
  "Audio": "音訊",
  "Samples": "樣本",
  "Tables": "資料表",
  "Type": "類型",
  "Size": "大小",
  "Status": "狀態",
  "Search": "搜尋",
  "Search Dataset...": "搜尋資料集...",
  "Search datasets...": "搜尋資料集...",
  "Items per page:": "每頁項目數：",
  "Try adjusting your search or filters": "請調整搜尋條件或篩選器後再試。",
  "Storage Available": "可用儲存空間",
  "Syncing": "同步中",
  "Ready": "就緒",
  "pending": "等待中",
  "running": "執行中",
  "succeeded": "成功",
  "failed": "失敗",
  "completed": "已完成",
  "generating": "產生中",
  "unknown": "未知",
  "null": "無",
  "group:": "群組：",
  "Empty": "空白",
  "Local deleted": "本機資料已刪除",
  "Table dataset": "資料表資料集",
  "Empty dataset": "空白資料集",
  "No matching dataset found": "找不到符合條件的資料集",
  "Try adjusting your search keywords": "請調整搜尋關鍵字後再試。",
  "No datasets found": "找不到資料集",
  "No dataset in your workspace.": "工作區中尚無資料集。",
  "Please click + Create Dataset to create one.": "請按一下「+ 建立資料集」新增資料集。",
  "This dataset is empty": "此資料集是空的",
  "To load data, please:": "若要載入資料，請：",
  "Go to": "前往",
  "Acquisition-Data": "資料擷取",
  "data loading...": "正在載入資料...",
  "Loading...": "載入中...",
  "Insufficient permissions": "權限不足",
  "Your role is": "您的角色是",
  "and you cannot make any changes to the dataset.": "，因此您無法變更資料集。",
  "If you want to operate the dataset, please contact the admin user to help upgrade your role to":
    "若要操作資料集，請聯絡管理員協助將您的角色升級為",
  "Data Acquisition": "資料擷取",
  "Manage datasets for acquisition, upload, and workspace ingestion workflows.":
    "管理資料擷取、上傳及匯入工作區流程所使用的資料集。",
  "Data Processing": "資料處理",
  "Clean, sample, remove redundant data, and generate synthetic samples from selected datasets.":
    "清理、取樣、移除重複資料，並從所選資料集產生合成樣本。",
  "Pre-Label": "預先標註",
  "Run Auto DAG, GroundingDINO, and FR pre-labeling workflows against selected datasets.":
    "對所選資料集執行 Auto DAG、GroundingDINO 與 FR 預先標註流程。",
  "Labels": "標籤",
  "Manage label definitions and assign label workflows across selected datasets.":
    "管理標籤定義，並為所選資料集安排標籤作業流程。",
  "CVAT Annotation": "CVAT 標註",
  "Create CVAT projects and manage dataset annotation tasks for selected datasets.":
    "建立 CVAT 專案並管理所選資料集的標註任務。",
  "ETL": "ETL",
  "Extract annotations from selected datasets and transform them into structured tables.":
    "擷取所選資料集的標註，並轉換成結構化資料表。",
  "Total Files:": "檔案總數：",
  "Total Labels:": "標籤總數：",
  "Classes:": "類別：",
  "No classes yet": "尚無類別",
  "No Label in this dataset": "此資料集中沒有標籤",
  "To get labels, please:": "若要取得標籤，請：",
  "There is no field in this dataset": "此資料集中沒有欄位",
  "To create a new field:": "若要建立新欄位：",
  "Select for batch ETL": "選取以進行批次 ETL",
  "Selected Datasets": "已選取的資料集",
  "Kubeflow Training": "Kubeflow 訓練",
  "Train Models": "訓練模型",
  "Launch training pipelines, monitor run status, and manage generated model artifacts.":
    "啟動訓練管線、監看執行狀態，並管理產生的模型成品。",
  "Total": "總數",
  "Running": "執行中",
  "Succeeded": "成功",
  "Failed": "失敗",
  "Please choose a model": "請選擇模型",
  "No training runs yet. Choose a model to start a pipeline.":
    "尚無訓練執行紀錄。請選擇模型以啟動管線。",
  "Model": "模型",
  "Model ID": "模型 ID",
  "Mapping": "對應",
  "Platform": "平台",
  "Group": "群組",
  "No advanced parameters.": "沒有進階參數。",
  "Deployment Artifact": "部署成品",
  "Generate NEF": "產生 NEF",
  "Convert succeeded training outputs into platform-ready NEF packages.":
    "將成功的訓練輸出轉換為可供平台使用的 NEF 套件。",
  "Generating": "產生中",
  "Completed": "已完成",
  "No eligible models yet. Complete training before generating NEF.":
    "尚無符合條件的模型。請先完成訓練，再產生 NEF。",
  "Annotation Workspace": "標註工作區",
  "Label Studio Projects": "Label Studio 專案",
  "Manage audio annotation projects, storage imports, exports, and ETL handoff.":
    "管理音訊標註專案、儲存空間匯入、匯出及 ETL 交接。",
  "Projects": "專案",
  "Audio Sources": "音訊來源",
  "Tasks": "任務",
  "Finished": "已完成",
  "Organization": "組織",
  "No organization": "尚無組織",
  "No Label Studio projects yet. Create a project to start annotation.":
    "尚無 Label Studio 專案。請建立專案以開始標註。",
  "Created": "建立時間",
  "No matching models found": "找不到符合條件的模型",
  "Please choose...": "請選擇...",
  "Organization settings": "組織設定",
  "Organization members": "組織成員",
  "Member": "成員",
  "Role": "角色",
  "Invite new member to": "邀請新成員加入",
  "Invitee email": "受邀者電子郵件",
  "They'll receive an email invite to join this workspace":
    "對方將收到加入此工作區的電子郵件邀請。",
  "Regular": "一般成員",
  "Organizer": "組織者",
  "Manage members, roles, and service credentials for": "管理下列組織的成員、角色與服務憑證：",
  "View members and roles for": "檢視下列組織的成員與角色：",
  "Your are not in any organization.": "您目前未加入任何組織。",
  "Please let admin or organizer invite your to an organization.":
    "請由管理員或組織管理者邀請您加入組織。",
  "Members": "成員",
  "People with access to": "可存取下列組織的人員：",
  "Removing a member revokes their access immediately": "移除成員後會立即撤銷其存取權。",
  "Training defaults": "訓練預設值",
  "Configure persistent defaults for each model in": "設定下列組織中各模型的持久預設值：",
  "Users may override values for one run, but cannot edit this saved configuration.":
    "使用者可在單次執行中覆寫值，但無法編輯這份已儲存的設定。",
  "Organization override": "組織覆寫值",
  "Code defaults": "程式碼預設值",
  "Merge order: code defaults → organization defaults → run input":
    "合併順序：程式碼預設值 → 組織預設值 → 執行輸入",
  "API keys": "API 金鑰",
  "Configure model, image, and search providers for this workspace":
    "設定此工作區使用的模型、圖片與搜尋服務供應商。",
  "Saved": "已儲存",
  "Mode": "模式",
  "Configured": "已設定",
  "Saved keys are never returned by the API": "API 永遠不會傳回已儲存的金鑰。",
  "Recommended providers": "建議的供應商",
  "Vision-capable LLMs": "具視覺能力的語言模型",
  "Image generation / editing": "圖片產生與編輯",
  "Language model": "語言模型",
  "Image editing": "圖片編輯",
  "Base URL": "基礎 URL",
  "API key": "API 金鑰",
  "Model name": "模型名稱",
  "LLM think mode": "語言模型思考模式",
  "Enable extended reasoning before responses": "在回覆前啟用延伸推理。",
  "Select base URL first": "請先選擇基礎 URL",
  "Select base url": "選擇基礎 URL",
  "Select model name": "選擇模型名稱",
  "Configured - enter a new key to replace": "已設定，輸入新金鑰即可取代",
  "Best cost / speed:": "最佳成本／速度：",
  "Balanced default:": "平衡型預設：",
  "Higher quality:": "較高品質：",
  "Edit-focused:": "著重編輯：",
  "for lightweight anomaly synthesis and fast vision reasoning.":
    "適合輕量異常合成與快速視覺推理。",
  "for routine anomaly synthesis with a good balance of quality, latency, and cost.":
    "適合一般異常合成，兼顧品質、延遲與成本。",
  "for difficult defects and stronger visual reasoning.":
    "適合困難缺陷與更強的視覺推理。",
  "when your deployment already uses OpenAI.": "適合已使用 OpenAI 的部署環境。",
  "Start with qwen3.7-plus; move to a faster model for high-volume workloads or a higher-quality model for difficult cases.":
    "建議先使用 qwen3.7-plus；大量工作負載可改用較快模型，困難案例則改用較高品質模型。",
  "for quick drafts and lightweight edits.": "適合快速草稿與輕量編輯。",
  "for text-to-image, editing, and batch generation.": "適合文字生圖、編輯與批次產生。",
  "when you need stronger consistency and visual fidelity.": "適合需要更高一致性與視覺保真度的情境。",
  "for image editing, or StepFun": "進行圖片編輯，或使用 StepFun",
  "as an OpenAI-compatible alternative.": "作為 OpenAI 相容的替代方案。",
  "Use Gemini lite for speed, qwen-image-2.0 for general workloads, and Gemini flash-image when output quality is the priority.":
    "重視速度時使用 Gemini lite，一般工作負載使用 qwen-image-2.0，優先考量輸出品質時使用 Gemini flash-image。",
  "or Bailian": "或 Bailian",
  "or Gemini": "或 Gemini",
  "or": "或",
  "Prefer": "建議使用",
  "for search in MLOps": "用於 MLOps 搜尋",
  "predictable HTTP API and good relevance/cost trade-off. Use alternatives only if you already have another compatible search endpoint.":
    "其 HTTP API 行為可預期，搜尋相關性與成本的平衡良好。只有在已有其他相容搜尋端點時，才建議改用替代方案。",
  "Reassign Dataset Organization": "重新指派資料集組織",
  "Admin only. Moves media / info / ETL folders and updates FiftyOne organization + sample filepaths.":
    "僅限管理員。移動媒體、資訊與 ETL 資料夾，並更新 FiftyOne 組織及樣本檔案路徑。",
  "Filter org": "篩選組織",
  "Media type": "媒體類型",
  "Target organization": "目標組織",
  "dataset name": "資料集名稱",
  "Select...": "請選擇...",
  "Loading datasets...": "正在載入資料集...",
  "No datasets match filters": "沒有符合篩選條件的資料集",
  "Name": "名稱",
  "All": "全部",
  "Join an organization to create projects": "加入組織後即可建立專案。",
  "Check it in CVAT": "前往 CVAT 查看",
  "stage:": "階段：",
  "project:": "專案：",
  "organization:": "組織：",
  "image_quality:": "圖片品質：",
  "annotation": "標註中",
  "acceptance": "驗收",
  "Disconnected with current cvat.": "已與目前的 CVAT 中斷連線。",
  "result url:": "結果網址：",
  "Currently being annotated in": "目前正在下列平台標註：",
  "Your Organization:": "您的組織：",
  "Choose organization:": "選擇組織：",
  "Choose project:": "選擇專案：",
  "Choose field:": "選擇欄位：",
  "Please choose an option": "請選擇選項",
  "--pure images--": "--純圖片--",
  "--all fields--": "--所有欄位--",
  "Choose project": "選擇專案",
  "segment size": "分段大小",
  "segment size:": "分段大小：",
  "is the maximum number of images to upload per job. Not applicable to videos.":
    "是每個工作可上傳的最大圖片數量，不適用於影片。",
  "If left empty, all images will be uploaded to one job.":
    "若留空，所有圖片將上傳至同一個工作。",
  "Uploading multiple datasets to CVAT": "正在將多個資料集上傳至 CVAT",
  "You didn't join any orgnaization yet, so please choose an organizatoin when uploading to CVAT":
    "您尚未加入任何組織，上傳至 CVAT 時請選擇組織。",
  "Labels:": "標籤：",
  "Yes": "是",
  "No": "否",
  "Model Mode": "模型模式",
  "DAG Selection": "DAG 選擇",
  "Source": "來源",
  "All sources": "所有來源",
  "Public DAGs": "公共 DAG",
  "Organization DAGs": "組織 DAG",
  "Search DAGs": "搜尋 DAG",
  "Search by name or directory": "依名稱或目錄搜尋",
  "Available DAGs": "可用 DAG",
  "Public catalog: YOLO": "公共目錄：YOLO",
  "No matching DAGs": "找不到符合條件的 DAG",
  "Selected DAG": "已選取的 DAG",
  "Sub DAG": "子 DAG",
  "Choose DAG": "選擇 DAG",
  "Choose a sub DAG": "請選擇子 DAG",
  "Choose a DAG and sub DAG first": "請先選擇 DAG 與子 DAG",
  "Select a DAG to continue": "請選擇 DAG 以繼續",
  "Selected DAG is no longer available": "已選取的 DAG 已無法使用",
  "Public scan details": "公共 DAG 掃描詳情",
  "Updated at": "更新時間",
  "Public DAG directory is unavailable": "公共 DAG 目錄無法存取",
  "Catalog cached for 5 minutes. Refresh to rescan now.": "目錄快取 5 分鐘。按重新整理可立即掃描。",
  "FR Mode": "人臉辨識模式",
  "Prompt Labels": "提示標籤",
  "Type label + Enter": "輸入標籤後按 Enter",
  "Smart Annotation": "智慧標註",
  "Model Training": "模型訓練",
  "Team Collaboration": "團隊協作",
  "A comprehensive data annotation and training platform": "完整的資料標註與模型訓練平台",
  "Join our platform to streamline your ML workflow": "加入平台，簡化您的機器學習工作流程",
  "Integrated with CVAT, supporting multiple data types annotation":
    "整合 CVAT，支援多種資料類型標註。",
  "Support training and evaluation of various deep learning models like YOLO, ResNet":
    "支援 YOLO、ResNet 等多種深度學習模型的訓練與評估。",
  "Organization-based permission management for team collaboration and data sharing":
    "以組織為基礎管理權限，支援團隊協作與資料共享。",
  "Log in": "登入",
  "Email Address": "電子郵件地址",
  "Password": "密碼",
  "Keep me logged in this browser": "在此瀏覽器保持登入",
  "Don't have an account?": "還沒有帳號？",
  "Create Account": "建立帳號",
  "Username": "使用者名稱",
  "Email": "電子郵件",
  "Confirm Password": "確認密碼",
  "Enter your username": "輸入使用者名稱",
  "Enter your email": "輸入電子郵件",
  "Create a password": "建立密碼",
  "Confirm your password": "再次輸入密碼",
  "Already have an account?": "已經有帳號？",
  "Sign up": "註冊",
  "Sign In": "登入",
  "404 Page Not Found": "404 找不到頁面",
  "Please check if the url path is correct.": "請檢查網址路徑是否正確。",
};

export const traditionalChinesePagePatterns = [
  [/^Generated (\d+) image\(s\)$/, "已生成 $1 張圖片"],
  [/^(\d+) matching DAGs$/, "$1 個符合條件的 DAG"],
  [/^(\d+) available, (\d+) excluded$/, "$1 個可用，$2 個已排除"],
  [/^(\d+) datasets$/, "$1 個資料集"],
  [/^Showing (\d+) of (\d+) datasets$/, "顯示 $1／$2 個資料集"],
  [/^Total (\d+) items$/, "共 $1 個項目"],
  [/^Search: "(.+)"$/, "搜尋：「$1」"],
  [/^(\d+) files$/, "$1 個檔案"],
  [/^Page (\d+) of (\d+)$/, "第 $1 頁，共 $2 頁"],
  [/^Selected (\d+) model\(s\)$/, "已選取 $1 個模型"],
  [/^Selected (\d+) dataset\(s\)$/, "已選取 $1 個資料集"],
  [/^Selected Datasets \((\d+)\)$/, "已選取的資料集（$1）"],
  [/^(\d+) members?$/, "$1 位成員"],
  [/^Priority (\d+)$/, "優先順序 $1"],
];
